module.exports = __webpack_public_path__ + "static/img/c6.a7c6df4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/success/c6.png
// module id = RcnU
// module chunks = 0